<app-moniepoint-dialog [icon]="iconRef">
  <div class="modal">
    <div class="text-center mb-[10px]">
      <div class="title mt-[24px]">
        User PIN
      </div>
      <div>
        Please enter your <b>4-Digit</b> User PIN
        to Proceed.
      </div>
    </div>
    <div *ngIf="isMobile" class="flex w-full justify-evenly">
      <app-password-input-box class="w-[246px]" id="userPin" (emitInput)="verifyPin($event)" [noOfPin]="4">
      </app-password-input-box>
    </div>
    <div *ngIf="!isMobile" nz-row nzJustify="center">
      <div nz-col nzSpan="18">
        <app-floating-label-input [controlDef]="pinControl" iconPosition="right" label="Enter User PIN"
          placeHolder="Enter User PIN">
        </app-floating-label-input>
      </div>

    </div>

    <div class="my-6" *ngIf="errorMessage">
      <app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>
    </div>

    <div class="border border-[#0361F0] mt-[41px] opacity-[0.17] mb-6"></div>

    <div class="flex items-center -mx-[7.5px]">
      <div class="w-6/12 px-[7.5px]">
        <app-custom-button [isBlock]="true" text="Dismiss" type="link" (click)="modal.destroy()">
        </app-custom-button>
      </div>

      <div class="w-6/12 px-[7.5px]">
        <app-custom-submit-button [block]="true" [submitting]="isLoading === true"
          [disabled]="isMobile ? disabled : this.form.invalid" (click)="submitPin()" name="Proceed">
        </app-custom-submit-button>
      </div>
    </div>
  </div>
</app-moniepoint-dialog>

<ng-template #iconRef>
  <img src="assets/images/svgs/transaction-pin-icon.svg" />
</ng-template>